<template>
  <div class="g-polygon">
    <h1>polygon</h1>
  </div>
</template>

<script>
import greenRegion from '../greenArea';
import redRegion from '../redArea';

export default {
  name: 'Polygon',
  data () {
    return {
        green: []
    }
  },
  props: ['map'],
  methods: {
    initGreenPoly() {
      this.$lodash.each(greenRegion, (polygon, key) => {
        let polyOptions = {
          path: polygon,
          strokeColor: "#0bdc7c",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#0bdc7c",
          fillOpacity: 0.3
        }
        var it = new google.maps.Polygon(polyOptions);
        it.setMap(this.map);
      });
    },
    initRedPoly() {
      this.$lodash.each(redRegion, (polygon, key) => {
        let polyOptions = {
          path: polygon,
          strokeColor: "#dc0b6b",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#dc0b6b",
          fillOpacity: 0.3
        }
        var it = new google.maps.Polygon(polyOptions);
        it.setMap(this.map);
      });
    }
  },
  created() {
    let interval = setInterval(() => {
      if (google && this.map) {
        this.initGreenPoly();
        this.initRedPoly();
        clearInterval(interval);
      }
    }, 500);
  },
  destroyed() {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/Polygon.vue